import Enum from "./Enum";

/**
 * NOTE: V2 outcome statuses are included in both V2 outcome
 * REQUESTS and RESPONSES. However, the safest way to determine
 * if an outcome is actually completed is to coerce its `completed`
 * property to a boolean. This is a compatible way to check both V1
 * and V2 outcome objects.
 */
export default Enum.create( {
	ALL: "ALL",
	COMPLETE: "COMPLETE",
	OUTSTANDING: "OUTSTANDING",
} );
